// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes fadeInGlobal {
    from {
        opacity: 0;

        /* Safari & Chrome */
        -webkit-opacity: 0;

        /* Firefox */
        -moz-opacity: 0;

        /* Internet Explorer */
        -ms-opacity: 0;

        /* Opera */
        -o-opacity: 0;
    }

    to {
        opacity: 1;

        /* Safari & Chrome */
        -webkit-opacity: 1;

        /* Firefox */
        -moz-opacity: 1;

        /* Internet Explorer */
        -ms-opacity: 1;

        /* Opera */
        -o-opacity: 1;
    }
}

@keyframes scaleGlobal {
    from {
        transform: scale(0);

        /* Safari & Chrome */
        -webkit-transform: scale(0);

        /* Firefox */
        -moz-transform: scale(0);

        /* Internet Explorer */
        -ms-transform: scale(0);

        /* Opera */
        -o-transform: scale(0);
    }

    to {
        transform: scale(1);

        /* Safari & Chrome */
        -webkit-transform: scale(1);

        /* Firefox */
        -moz-transform: scale(1);

        /* Internet Explorer */
        -ms-transform: scale(1);

        /* Opera */
        -o-transform: scale(1);
    }
}

@keyframes fadeOutGlobal {
    from {
        opacity: 1;

        /* Safari & Chrome */
        -webkit-opacity: 1;

        /* Firefox */
        -moz-opacity: 1;

        /* Internet Explorer */
        -ms-opacity: 1;

        /* Opera */
        -o-opacity: 1;
    }

    to {
        display: none;
        opacity: 0;

        /* Safari & Chrome */
        -webkit-opacity: 0;

        /* Firefox */
        -moz-opacity: 0;

        /* Internet Explorer */
        -ms-opacity: 0;

        /* Opera */
        -o-opacity: 0;
    }
}

@keyframes moveRightGlobal {
    from {
        transform: translateX(-100%);

        /* Safari & Chrome */
        -webkit-transform: translateX(-100%);

        /* Firefox */
        -moz-transform: translateX(-100%);

        /* Internet Explorer */
        -ms-transform: translateX(-100%);

        /* Opera */
        -o-transform: translateX(-100%);
    }

    to {
        transform: translateX(auto);

        /* Safari & Chrome */
        -webkit-transform: translateX(auto);

        /* Firefox */
        -moz-transform: translateX(auto);

        /* Internet Explorer */
        -ms-transform: translateX(auto);

        /* Opera */
        -o-transform: translateX(auto);
    }
}

@keyframes moveLeftGlobal {
    from {
        transform: translateX(100%);

        /* Safari & Chrome */
        -webkit-transform: translateX(100%);

        /* Firefox */
        -moz-transform: translateX(100%);

        /* Internet Explorer */
        -ms-transform: translateX(100%);

        /* Opera */
        -o-transform: translateX(100%);
    }

    to {
        transform: translateX(auto);

        /* Safari & Chrome */
        -webkit-transform: translateX(auto);

        /* Firefox */
        -moz-transform: translateX(auto);

        /* Internet Explorer */
        -ms-transform: translateX(auto);

        /* Opera */
        -o-transform: translateX(auto);
    }
}

@keyframes globalPressAnimation {
    0% {
        transform: scale(1);

        /* Safari & Chrome */
        -webkit-transform: scale(1);

        /* Firefox */
        -moz-transform: scale(1);

        /* Internet Explorer */
        -ms-transform: scale(1);

        /* Opera */
        -o-transform: scale(1);
    }

    50% {
        transform: scale(0.82);

        /* Safari & Chrome */
        -webkit-transform: scale(0.82);

        /* Firefox */
        -moz-transform: scale(0.82);

        /* Internet Explorer */
        -ms-transform: scale(0.82);

        /* Opera */
        -o-transform: scale(0.82);
    }

    to {
        transform: scale(1);

        /* Safari & Chrome */
        -webkit-transform: scale(1);

        /* Firefox */
        -moz-transform: scale(1);

        /* Internet Explorer */
        -ms-transform: scale(1);

        /* Opera */
        -o-transform: scale(1);
    }
}
`, "",{"version":3,"sources":["webpack://./src/style/animations.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;;QAEV,oBAAoB;QACpB,kBAAkB;;QAElB,YAAY;QACZ,eAAe;;QAEf,sBAAsB;QACtB,cAAc;;QAEd,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,UAAU;;QAEV,oBAAoB;QACpB,kBAAkB;;QAElB,YAAY;QACZ,eAAe;;QAEf,sBAAsB;QACtB,cAAc;;QAEd,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,mBAAmB;;QAEnB,oBAAoB;QACpB,2BAA2B;;QAE3B,YAAY;QACZ,wBAAwB;;QAExB,sBAAsB;QACtB,uBAAuB;;QAEvB,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;;QAEnB,oBAAoB;QACpB,2BAA2B;;QAE3B,YAAY;QACZ,wBAAwB;;QAExB,sBAAsB;QACtB,uBAAuB;;QAEvB,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,UAAU;;QAEV,oBAAoB;QACpB,kBAAkB;;QAElB,YAAY;QACZ,eAAe;;QAEf,sBAAsB;QACtB,cAAc;;QAEd,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,UAAU;;QAEV,oBAAoB;QACpB,kBAAkB;;QAElB,YAAY;QACZ,eAAe;;QAEf,sBAAsB;QACtB,cAAc;;QAEd,UAAU;QACV,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,4BAA4B;;QAE5B,oBAAoB;QACpB,oCAAoC;;QAEpC,YAAY;QACZ,iCAAiC;;QAEjC,sBAAsB;QACtB,gCAAgC;;QAEhC,UAAU;QACV,+BAA+B;IACnC;;IAEA;QACI,2BAA2B;;QAE3B,oBAAoB;QACpB,mCAAmC;;QAEnC,YAAY;QACZ,gCAAgC;;QAEhC,sBAAsB;QACtB,+BAA+B;;QAE/B,UAAU;QACV,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,2BAA2B;;QAE3B,oBAAoB;QACpB,mCAAmC;;QAEnC,YAAY;QACZ,gCAAgC;;QAEhC,sBAAsB;QACtB,+BAA+B;;QAE/B,UAAU;QACV,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;;QAE3B,oBAAoB;QACpB,mCAAmC;;QAEnC,YAAY;QACZ,gCAAgC;;QAEhC,sBAAsB;QACtB,+BAA+B;;QAE/B,UAAU;QACV,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,mBAAmB;;QAEnB,oBAAoB;QACpB,2BAA2B;;QAE3B,YAAY;QACZ,wBAAwB;;QAExB,sBAAsB;QACtB,uBAAuB;;QAEvB,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;;QAEtB,oBAAoB;QACpB,8BAA8B;;QAE9B,YAAY;QACZ,2BAA2B;;QAE3B,sBAAsB;QACtB,0BAA0B;;QAE1B,UAAU;QACV,yBAAyB;IAC7B;;IAEA;QACI,mBAAmB;;QAEnB,oBAAoB;QACpB,2BAA2B;;QAE3B,YAAY;QACZ,wBAAwB;;QAExB,sBAAsB;QACtB,uBAAuB;;QAEvB,UAAU;QACV,sBAAsB;IAC1B;AACJ","sourcesContent":["@keyframes fadeInGlobal {\n    from {\n        opacity: 0;\n\n        /* Safari & Chrome */\n        -webkit-opacity: 0;\n\n        /* Firefox */\n        -moz-opacity: 0;\n\n        /* Internet Explorer */\n        -ms-opacity: 0;\n\n        /* Opera */\n        -o-opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n\n        /* Safari & Chrome */\n        -webkit-opacity: 1;\n\n        /* Firefox */\n        -moz-opacity: 1;\n\n        /* Internet Explorer */\n        -ms-opacity: 1;\n\n        /* Opera */\n        -o-opacity: 1;\n    }\n}\n\n@keyframes scaleGlobal {\n    from {\n        transform: scale(0);\n\n        /* Safari & Chrome */\n        -webkit-transform: scale(0);\n\n        /* Firefox */\n        -moz-transform: scale(0);\n\n        /* Internet Explorer */\n        -ms-transform: scale(0);\n\n        /* Opera */\n        -o-transform: scale(0);\n    }\n\n    to {\n        transform: scale(1);\n\n        /* Safari & Chrome */\n        -webkit-transform: scale(1);\n\n        /* Firefox */\n        -moz-transform: scale(1);\n\n        /* Internet Explorer */\n        -ms-transform: scale(1);\n\n        /* Opera */\n        -o-transform: scale(1);\n    }\n}\n\n@keyframes fadeOutGlobal {\n    from {\n        opacity: 1;\n\n        /* Safari & Chrome */\n        -webkit-opacity: 1;\n\n        /* Firefox */\n        -moz-opacity: 1;\n\n        /* Internet Explorer */\n        -ms-opacity: 1;\n\n        /* Opera */\n        -o-opacity: 1;\n    }\n\n    to {\n        display: none;\n        opacity: 0;\n\n        /* Safari & Chrome */\n        -webkit-opacity: 0;\n\n        /* Firefox */\n        -moz-opacity: 0;\n\n        /* Internet Explorer */\n        -ms-opacity: 0;\n\n        /* Opera */\n        -o-opacity: 0;\n    }\n}\n\n@keyframes moveRightGlobal {\n    from {\n        transform: translateX(-100%);\n\n        /* Safari & Chrome */\n        -webkit-transform: translateX(-100%);\n\n        /* Firefox */\n        -moz-transform: translateX(-100%);\n\n        /* Internet Explorer */\n        -ms-transform: translateX(-100%);\n\n        /* Opera */\n        -o-transform: translateX(-100%);\n    }\n\n    to {\n        transform: translateX(auto);\n\n        /* Safari & Chrome */\n        -webkit-transform: translateX(auto);\n\n        /* Firefox */\n        -moz-transform: translateX(auto);\n\n        /* Internet Explorer */\n        -ms-transform: translateX(auto);\n\n        /* Opera */\n        -o-transform: translateX(auto);\n    }\n}\n\n@keyframes moveLeftGlobal {\n    from {\n        transform: translateX(100%);\n\n        /* Safari & Chrome */\n        -webkit-transform: translateX(100%);\n\n        /* Firefox */\n        -moz-transform: translateX(100%);\n\n        /* Internet Explorer */\n        -ms-transform: translateX(100%);\n\n        /* Opera */\n        -o-transform: translateX(100%);\n    }\n\n    to {\n        transform: translateX(auto);\n\n        /* Safari & Chrome */\n        -webkit-transform: translateX(auto);\n\n        /* Firefox */\n        -moz-transform: translateX(auto);\n\n        /* Internet Explorer */\n        -ms-transform: translateX(auto);\n\n        /* Opera */\n        -o-transform: translateX(auto);\n    }\n}\n\n@keyframes globalPressAnimation {\n    0% {\n        transform: scale(1);\n\n        /* Safari & Chrome */\n        -webkit-transform: scale(1);\n\n        /* Firefox */\n        -moz-transform: scale(1);\n\n        /* Internet Explorer */\n        -ms-transform: scale(1);\n\n        /* Opera */\n        -o-transform: scale(1);\n    }\n\n    50% {\n        transform: scale(0.82);\n\n        /* Safari & Chrome */\n        -webkit-transform: scale(0.82);\n\n        /* Firefox */\n        -moz-transform: scale(0.82);\n\n        /* Internet Explorer */\n        -ms-transform: scale(0.82);\n\n        /* Opera */\n        -o-transform: scale(0.82);\n    }\n\n    to {\n        transform: scale(1);\n\n        /* Safari & Chrome */\n        -webkit-transform: scale(1);\n\n        /* Firefox */\n        -moz-transform: scale(1);\n\n        /* Internet Explorer */\n        -ms-transform: scale(1);\n\n        /* Opera */\n        -o-transform: scale(1);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
